<ng-container *ngIf="isScreenLarge$ | async; else mobilePhoto">
    <ins-table-list-desktop [loaded]="loaded" [photos]="photos">
        <ng-container *ngFor="let photo of photos">
            <ins-photo-content [photo]="photo" [isMobile]="false"></ins-photo-content>
        </ng-container>
    </ins-table-list-desktop>
</ng-container>

<ng-template #mobilePhoto>
    <ins-table-list-mobile [loaded]="loaded" [photos]="photos">
        <ng-container *ngFor="let photo of photos; let i = index">
            <ins-photo-content [photoIndex]="i" [photo]="photo" [isMobile]="true"></ins-photo-content>
        </ng-container>
    </ins-table-list-mobile>
</ng-template>
